import { render, staticRenderFns } from "./TariffZones.vue?vue&type=template&id=bd0496da&"
import script from "./TariffZones.vue?vue&type=script&lang=ts&"
export * from "./TariffZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports